export const handleKeypress = {
  methods: {
    preventKeypress (event) {
      // 
      // 
      if (event.keyCode === 46) {
        event.preventDefault()
      }
    }
  }
}

//keyCode 46 = dot key ["."]